import { useTranslation } from 'react-i18next';

import Categories from '@/routes/(app)/agents/components/categories';
import DataMetrics from '@/routes/(app)/agents/components/data-metrics';

const DataAgent = () => {
  const { t } = useTranslation();

  return (
    <>
      <h1 className='text-4xl font-bold'>{t('dataAgent.title')}</h1>
      <p className='text-muted-foreground'>{t('dataAgent.description')}</p>
      <DataMetrics />
      <Categories />
    </>
  );
};

export default DataAgent;
